import { render, staticRenderFns } from "./active-card.vue?vue&type=template&id=29c748a4"
import script from "./active-card.vue?vue&type=script&lang=js"
export * from "./active-card.vue?vue&type=script&lang=js"
import style0 from "./active-card.vue?vue&type=style&index=0&id=29c748a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports